import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import StarRating from '@/components/common/StarRating.vue'
  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackPriceSection',
  props: {
    rating: {
      type: Number,
      required: true,
    },
    userComment: {
      type: String,
      required: true,
    },
    isPurchased: {
      type: Boolean,
      required: true,
    },
    productAmount: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const { purchaseIcon } = useIcons()
  const { currencyFormatDE, productDiscountValue } = useCommonMixin()
  const { canBuyCourses } = useCourse()

  const discount = computed(() => {
    if (route.params.discount) return Number(route.params.discount)
    return productDiscountValue
  })

  const discountValue = computed(() => {
    const amount = props.productAmount || 0
    return currencyFormatDE(amount + Number(discount.value) * amount)
  })

return { __sfc: true,props, route, purchaseIcon, currencyFormatDE, productDiscountValue, canBuyCourses, discount, discountValue, computed, SVGRenderer, StarRating, useIcons, useCommonMixin, useCourse, useRoute }
}

})